module.exports = __webpack_public_path__ + "img/puzzle.f793bd64.svg";